export class RelatedDocsView {
    public document: number;
    public relatedDoc: number;
    public memoType: string;
    public issueRefund: string;
    public agent: number;
    public relatedAmount: number;
    public currency: string;
    public excluded: boolean;

  constructor(document, memoType, relatedDoc, issueRefund, agent, relatedAmount, currency, excluded) {
      this.document = document;
      this.memoType = memoType;
      this.relatedDoc = relatedDoc;
      this.issueRefund = issueRefund;
      this.agent = agent;
      this.relatedAmount = relatedAmount;
      this.currency = currency;
      this.excluded = excluded;
    }
}
